// removed by extract-text-webpack-plugin
module.exports = {"ccExpiration":"_1_PNe","ccLastFour":"_3TWMH","cc":"_1LP0m","ccVisa":"_2GMka _1LP0m","ccAmericanExpress":"_2GmwM _1LP0m","ccMasterCard":"_2GkuA _1LP0m","ccDiscover":"_3J4LP _1LP0m","ccDefault":"_20TLb _1LP0m","ccApplePay":"_3opbO _1LP0m","ccAndroidPay":"g07J8 _1LP0m"};


//////////////////
// WEBPACK FOOTER
// ./banquet/components/PaymentMethod/index.sass
// module id = 1495
// module chunks = 1